import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

import ThirdPartyLicensesView from "views/user/about/ThirdPartyLicensesView.jsx";

export default function AboutView(props) {
		
	const { okCallback } = props;
	const [selected, setSelected] = useState(0);
	const [version, setVersion] = useState("...");
	const navigate = useNavigate();
	const focusRef = useRef(null);
	
	useEffect(() => {
		let options = {
			credentials: "include",
			method: "GET",
			headers: { "Content-Type": "application/json" } 
		};
		fetch(API_URL + '/public/version', options
		).then((response) => {
			if (response.ok) { return response.text(); }
			else { throw new Error(response.status); }
		}).then((str) => {
			setVersion(str);
		}).catch(() => {
			setVersion("unavailable");
		});
	}, []);
	
	useEffect(() => {
		focusRef.current.focus();
	}, [version]);
	
	const siteMapClicked = (e) => {
		e.preventDefault();
		navigate('/sitemap', { replace: true });
		okCallback();
	};

	return (
		<div className="constituo-about-view" role="region" aria-label="About Dialog" tabIndex={0} ref={focusRef}>
			<TabStrip 
				className="constituo-about-tabs-container"
				selected={selected} 
				onSelect={(e) => setSelected(e.selected)}
			>
				<TabStripTab
					title={<div className="constituo-procedure-tab">{"Constituo"}</div>}
					key="constituo"
					contentClassName="constituo-about-container"
				>
					<div style={{ position: "relative", display: "block", fontSize: "12.8px", fontFamily: "Arial" }}>
						<div className="about-logo ubuntu">
							<span className="fa fa-cs-logo"></span>
								{"constituo"}
							<span id="about-registered-mark" className="fa fa-registered ubuntu"></span>
						</div>
						<div style={{ 
								marginTop: "10px", 
								paddingLeft: "10px", 
								paddingRight: "10px", 
								width: "100%",
								boxSizing: "border-box", 
								textAlign: "center"
							}}>
							Constituo Content is a content services platform making it easier than ever to manage business processes across your entire campus. The platform utilize the modern, robust, and industry-leading technology infrastructure provided by Amazon Web Services (AWS), as well as other leading service providers, to provide the only content services platform built just for higher ed.
							<p style={{ color: "#E4973C", fontWeight: "bold"}}>Smarter and Faster Campus Processes</p>
						</div>	          
						<div style={{ listStyleType: "none", textAlign: "center", marginTop: "20px", fontSize: "12px"}}>
							<div style={{ display: "block" }}>
								<div style={{ display: "inline-block", width: "140px"}}>Constituo Content:</div>{version}
							</div>
						</div>		
						<p/>					
						<div style={{ display: "flex", justifyContent: "center" }}>
							<a href="https://resources.constituosoftware.com/ConstituoSoftwareAcceptableUsePolicy.pdf" target="_blank">Acceptable Use Policy</a>
						</div>	          		
						<div style={{ display: "flex", justifyContent: "center" }}>
							<a href="#/sitemap" onClick={siteMapClicked}>Site Map</a>
						</div>
					</div>
				</TabStripTab>
				<TabStripTab
					title={<div className="constituo-procedure-tab">{ "Third Party" }</div>}
					key="thirdparty"
					contentClassName="constituo-about-container"
				>
					<ThirdPartyLicensesView />
				</TabStripTab>
			</TabStrip>
			<div id="about-copyright">
				<span className="fa fa-copyright"></span>
				<span className="copyright-year">{(new Date()).getFullYear()}</span>{" Constituo Software. All rights reserved."}
			</div>
		</div>
	);
}
